module.exports = __webpack_public_path__ + "img/finance_aset.644ac741.svg";